import _ from 'lodash'

// Smushes a Firebase returned object into array of objects with key in specified prop
export const smush = (firebaseSnapOfObjects, keyProp = '__id') => {
	return _.map(firebaseSnapOfObjects.val(), (obj, key) => {
		obj[keyProp] = key
		return obj
	})
}



// WEBPACK FOOTER //
// ./src/lib/firebaseUtils.js